const defaultProps = {
  size: 'sm',
}

export default {
  defaultProps,
}
